import { TestDefinition, QuestionType } from '../../types';

// Escala 0-3 para PID-5-BF
const pid5Scale = [
  { label: '0 - Muy falso o a menudo falso', value: 0 },
  { label: '1 - Algo falso o a veces falso', value: 1 },
  { label: '2 - Algo verdadero o a veces verdadero', value: 2 },
  { label: '3 - Muy verdadero o a menudo verdadero', value: 3 }
];

export const TESTS_PERSONALIDAD: TestDefinition[] = [
  {
    id: 'pid-5-bf',
    code: 'PID-5-BF',
    name: 'Personality Inventory for DSM-5 Brief Form',
    category: 'Personalidad',
    description: 'Evaluación de rasgos de personalidad desadaptativos según DSM-5. 25 ítems que evalúan 5 dominios: Afectividad Negativa, Desapego, Antagonismo, Desinhibición y Psicoticismo. Desarrollado por APA (2013).',
    questions: [
      // AFECTIVIDAD NEGATIVA (5 ítems)
      {
        id: 'p1',
        text: '1. Las personas me dicen a menudo que me enojo muy rápido',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Afectividad Negativa'
      },
      {
        id: 'p2',
        text: '2. Siento que no valgo nada',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Afectividad Negativa'
      },
      {
        id: 'p3',
        text: '3. Temo hacer el ridículo en situaciones sociales',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Afectividad Negativa'
      },
      {
        id: 'p4',
        text: '4. Experimento cambios de humor muy repentinos',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Afectividad Negativa'
      },
      {
        id: 'p5',
        text: '5. Me preocupo por casi todo',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Afectividad Negativa'
      },

      // DESAPEGO (5 ítems)
      {
        id: 'p6',
        text: '6. No me interesa hacer amigos',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desapego'
      },
      {
        id: 'p7',
        text: '7. Evito la mayoría de las situaciones sociales',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desapego'
      },
      {
        id: 'p8',
        text: '8. No siento emoción ni entusiasmo por la mayoría de las cosas',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desapego'
      },
      {
        id: 'p9',
        text: '9. Rara vez siento emociones fuertes',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desapego'
      },
      {
        id: 'p10',
        text: '10. No tengo mayor interés en establecer relaciones románticas',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desapego'
      },

      // ANTAGONISMO (5 ítems)
      {
        id: 'p11',
        text: '11. No me importa si ofendo a otras personas para obtener lo que quiero',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonismo'
      },
      {
        id: 'p12',
        text: '12. No respeto las reglas de la sociedad',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonismo'
      },
      {
        id: 'p13',
        text: '13. No puedo resistir el impulso de manipular a otros',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonismo'
      },
      {
        id: 'p14',
        text: '14. Estafa o engaño a otros',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonismo'
      },
      {
        id: 'p15',
        text: '15. Tiendo a molestarme o irritarme con personas que no hacen las cosas a mi manera',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonismo'
      },

      // DESINHIBICIÓN (5 ítems)
      {
        id: 'p16',
        text: '16. A menudo actúo impulsivamente',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desinhibición'
      },
      {
        id: 'p17',
        text: '17. Tiendo a distraerme con facilidad',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desinhibición'
      },
      {
        id: 'p18',
        text: '18. La gente me dice que soy irresponsable',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desinhibición'
      },
      {
        id: 'p19',
        text: '19. Hago cosas arriesgadas sin pensar en las consecuencias',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desinhibición'
      },
      {
        id: 'p20',
        text: '20. A menudo dejo que las cosas se desordenen',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Desinhibición'
      },

      // PSICOTICISMO (5 ítems)
      {
        id: 'p21',
        text: '21. Tengo algunas experiencias inusuales que la mayoría de la gente no tiene',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psicoticismo'
      },
      {
        id: 'p22',
        text: '22. A veces hago cosas que otros encuentran raras',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psicoticismo'
      },
      {
        id: 'p23',
        text: '23. He tenido experiencias que no puedo explicar',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psicoticismo'
      },
      {
        id: 'p24',
        text: '24. Tengo pensamientos que parecen extraños a los demás',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psicoticismo'
      },
      {
        id: 'p25',
        text: '25. Me cuesta mantener la concentración en mis pensamientos',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psicoticismo'
      }
    ],
    subscales: [
      {
        name: 'Afectividad Negativa',
        questionIds: ['p1', 'p2', 'p3', 'p4', 'p5'],
        description: 'Labilidad emocional, ansiedad, inseguridad, hostilidad'
      },
      {
        name: 'Desapego',
        questionIds: ['p6', 'p7', 'p8', 'p9', 'p10'],
        description: 'Aislamiento, anhedonia, restricción afectiva'
      },
      {
        name: 'Antagonismo',
        questionIds: ['p11', 'p12', 'p13', 'p14', 'p15'],
        description: 'Manipulación, engaño, grandiosidad, insensibilidad'
      },
      {
        name: 'Desinhibición',
        questionIds: ['p16', 'p17', 'p18', 'p19', 'p20'],
        description: 'Impulsividad, irresponsabilidad, distracción, riesgo'
      },
      {
        name: 'Psicoticismo',
        questionIds: ['p21', 'p22', 'p23', 'p24', 'p25'],
        description: 'Experiencias perceptuales inusuales, creencias extrañas'
      }
    ],
    interpretations: [
      { min: 0, max: 18, label: 'Rasgos Adaptativos', color: 'bg-green-100 text-green-800' },
      { min: 19, max: 37, label: 'Rasgos Leves', color: 'bg-yellow-100 text-yellow-800' },
      { min: 38, max: 56, label: 'Rasgos Moderados', color: 'bg-orange-100 text-orange-800' },
      { min: 57, max: 75, label: 'Rasgos Marcados', color: 'bg-red-200 text-red-900' }
    ]
  }
  ,

  {
    id: 'bfi-10',
    code: 'BFI-10',
    name: 'Big Five Inventory - 10 Items',
    category: 'Personalidad',
    description: 'Versión ultra-breve de 10 ítems para evaluar los Cinco Grandes rasgos de personalidad. Desarrollado por Rammstedt & John (2007). Autoadministrado. Útil para screening rápido de dimensiones de personalidad.',
    questions: [
      { id: 'bfi1', text: '1. Me veo a mí mismo como alguien... reservado', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 5}, {label: 'En desacuerdo', value: 4}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 2}, {label: 'Muy de acuerdo', value: 1}]},
      { id: 'bfi2', text: '2. Me veo a mí mismo como alguien... generalmente confiado', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 1}, {label: 'En desacuerdo', value: 2}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 4}, {label: 'Muy de acuerdo', value: 5}]},
      { id: 'bfi3', text: '3. Me veo a mí mismo como alguien... tendiente a ser perezoso', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 5}, {label: 'En desacuerdo', value: 4}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 2}, {label: 'Muy de acuerdo', value: 1}]},
      { id: 'bfi4', text: '4. Me veo a mí mismo como alguien... relajado, maneja bien el estrés', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 5}, {label: 'En desacuerdo', value: 4}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 2}, {label: 'Muy de acuerdo', value: 1}]},
      { id: 'bfi5', text: '5. Me veo a mí mismo como alguien... con pocos intereses artísticos', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 5}, {label: 'En desacuerdo', value: 4}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 2}, {label: 'Muy de acuerdo', value: 1}]},
      { id: 'bfi6', text: '6. Me veo a mí mismo como alguien... extrovertido, entusiasta', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 1}, {label: 'En desacuerdo', value: 2}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 4}, {label: 'Muy de acuerdo', value: 5}]},
      { id: 'bfi7', text: '7. Me veo a mí mismo como alguien... tendiente a encontrar fallas en otros', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 5}, {label: 'En desacuerdo', value: 4}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 2}, {label: 'Muy de acuerdo', value: 1}]},
      { id: 'bfi8', text: '8. Me veo a mí mismo como alguien... que hace un trabajo minucioso', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 1}, {label: 'En desacuerdo', value: 2}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 4}, {label: 'Muy de acuerdo', value: 5}]},
      { id: 'bfi9', text: '9. Me veo a mí mismo como alguien... que se pone nervioso fácilmente', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 1}, {label: 'En desacuerdo', value: 2}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 4}, {label: 'Muy de acuerdo', value: 5}]},
      { id: 'bfi10', text: '10. Me veo a mí mismo como alguien... con imaginación activa', type: QuestionType.LIKERT, options: [{label: 'Muy en desacuerdo', value: 1}, {label: 'En desacuerdo', value: 2}, {label: 'Neutro', value: 3}, {label: 'De acuerdo', value: 4}, {label: 'Muy de acuerdo', value: 5}]}
    ],
    subscales: [
      { id: 'extraversion', name: 'Extraversión', questionIds: ['bfi1', 'bfi6'], description: 'Sociabilidad, energía y actividad (bfi1 inverso + bfi6)' },
      { id: 'agreeableness', name: 'Amabilidad', questionIds: ['bfi2', 'bfi7'], description: 'Confianza, cooperación y empatía (bfi2 + bfi7 inverso)' },
      { id: 'conscientiousness', name: 'Escrupulosidad', questionIds: ['bfi3', 'bfi8'], description: 'Organización, responsabilidad y autocontrol (bfi3 inverso + bfi8)' },
      { id: 'neuroticism', name: 'Neuroticismo', questionIds: ['bfi4', 'bfi9'], description: 'Inestabilidad emocional y tendencia al estrés (bfi4 inverso + bfi9)' },
      { id: 'openness', name: 'Apertura', questionIds: ['bfi5', 'bfi10'], description: 'Curiosidad intelectual e imaginación (bfi5 inverso + bfi10)' }
    ],
    interpretations: [
      { min: 10, max: 23, label: 'Perfil Bajo en Rasgos Positivos', color: 'bg-blue-100 text-blue-800' },
      { min: 24, max: 36, label: 'Perfil Moderado', color: 'bg-green-100 text-green-800' },
      { min: 37, max: 50, label: 'Perfil Alto en Rasgos Positivos', color: 'bg-purple-100 text-purple-800' }
    ]
  }
];
